import { Grid, IconButton, Typography } from "@mui/material";
import { useOpenDialog } from "app/components/dialog/hooks/useOpenDialog";
import { Iconify } from "app/components/Iconify";
import { formatDateTimeStringFull } from "app/helpers/date";

import { useVersionQuery } from "../api/readVersion/hook";

export const AboutIcon = () => {
  const openDialog = useOpenDialog();
  const { data: version } = useVersionQuery();

  const showAbout = () => {
    openDialog({
      actions: [
        {
          color: "primary",
          label: "Close",
        },
      ],
      content: (
        <Grid container spacing={2}>
          <Grid size={{ sm: 3, xs: 12 }}>
            <Typography variant="body1">Verze:</Typography>
          </Grid>
          <Grid size={{ sm: 9, xs: 12 }}>
            <Typography variant="body2">
              {version?.majorVersion.number}.
              {(version?.sequence ?? 0) -
                (version?.majorVersion.createdAtCommitSequence ?? 0)}{" "}
              ({version?.commitHash ? version.commitHash.slice(0, 7) : "???"})
            </Typography>
          </Grid>
          <Grid size={{ sm: 3, xs: 12 }}>
            <Typography variant="body1">Release:</Typography>
          </Grid>
          <Grid size={{ sm: 9, xs: 12 }}>
            <Typography variant="body2">
              {formatDateTimeStringFull(version?.releasedAt ?? "")}
            </Typography>
          </Grid>
        </Grid>
      ),
      title: "O aplikaci",
    });
  };

  return (
    <IconButton onClick={showAbout}>
      <Iconify icon="ix:about" />
    </IconButton>
  );
};
